import { api } from '../../../App';
import { FormInfo } from '../../../model/FormInfo';
import { parseFormInfo } from '../../../parsers/formInfo.parser';

export const getPatientFormInfo = async (): Promise<FormInfo> => {
  const response = await api.forms.apiFormInfoPatientRegistrationGet();
  return parseFormInfo(response.data);
};
